<app-new-version-banner />
<router-outlet />
